exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#servitudeCardModal .v--modal-box.v--modal{min-height:410px!important;min-width:460px!important}#servitudeCardModal .v-subheader{font-size:14px!important;color:#000!important;font-weight:600!important}#servitudeCardModal .v-tabs__div:not(:last-child){padding-right:5px}#servitudeCardModal .v-tabs__div{background-image:linear-gradient(180deg,#2a579a 0,#2a579a),linear-gradient(180deg,#fff 0,#fff);background-clip:content-box,padding-box}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3be290de","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/servitude/modals/ServitudeCard.vue
// module id = 1877
// module chunks = 0